var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"py-2 px-4 text-body-1 font-weight-light"},[_vm._v("© 2019 - "+_vm._s(_vm.currentYear))])
}
var staticRenderFns = []

export { render, staticRenderFns }